import React from 'react';
const FlagIcon = (props) => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.75 14.3125C1.75 14.5586 1.53125 14.75 1.3125 14.75H0.4375C0.191406 14.75 0 14.5586 0 14.3125V1.625C0 1.16016 0.382812 0.75 0.875 0.75C1.33984 0.75 1.75 1.16016 1.75 1.625V14.3125ZM13.0156 0.75C12.8242 0.75 12.6602 0.804688 12.4688 0.886719C11.2383 1.46094 10.3086 1.65234 9.54297 1.65234C7.90234 1.65234 6.94531 0.777344 5.05859 0.777344C4.375 0.777344 3.58203 0.886719 2.625 1.1875V10.7852C3.5 10.5117 4.23828 10.4023 4.92188 10.4023C6.94531 10.4023 8.33984 11.25 10.3633 11.25C11.2383 11.25 12.2227 11.0859 13.3984 10.6211C13.7812 10.4844 14 10.1836 14 9.85547V1.59766C14 1.07812 13.5352 0.75 13.0156 0.75Z"
      fill="#622FEE"
    />
  </svg>
);

export default FlagIcon;
